/* eslint-disable */
// import Swiper from "swiper/bundle";
//import Swiper from "swiper";

import { transform } from "lodash-es";

/* eslint-enable */

class FeaturedContentTextImageNumbers {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleNumbers = this.sectionsContainer.querySelector('.featured-content-text-image-numbers');
		
		if (!this.$moduleNumbers)
			return;
		
		this.$moduleNumbersElements = this.$moduleNumbers.querySelectorAll('.anima');
		this.$moduleNumbersImage = this.$moduleNumbers.querySelectorAll('.image');
		this.$numbresAnimation = this.$moduleNumbers.querySelectorAll('.number span');
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
        gsap.set(this.$moduleNumbers, { opacity: 0.0001 });
        gsap.set(this.$moduleNumbersImage, { opacity: 0.0001, scale: 0.9, transformOrigin: 'center center'});
        gsap.set(this.$moduleNumbersElements, { yPercent: 20, opacity: 0.0001 , onComplete: () => {
			this.initAnimate();
			this.initAnimationNumber();
		} });
	}

	initAnimate() {
		this.animateModuleNumbres = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleNumbers,
				start: 'top 70%'
			},
			onComplete: () => {
				gsap.set(this.$moduleNumbersElements, { clearProps: true });
			}
        });
    
		this.animateModuleNumbres.addLabel('step1');
		this.animateModuleNumbres.to(this.$moduleNumbers, { opacity: 1}, 'step1');
        this.animateModuleNumbres.to(this.$moduleNumbersImage, { opacity: 1, scale: 1 }, 'step1');
		this.animateModuleNumbres.to(this.$moduleNumbersElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}

	initAnimationNumber() {     
		var separator = '.';
		if ( document.body.classList.contains('lang-en')) {
			separator = ',';

		}
		
		
        this.$numbresAnimation.forEach((item, index) => {
            this.countEl = item;
            gsap.to(this.countEl, {
				innerText: this.countEl.parentNode.getAttribute("data-number"),
				duration: 2,
				modifiers: {
					innerText: (innerText) => {
						return gsap.utils
						.snap(1, innerText)
						.toString()
						.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
					}
				},

                scrollTrigger: {
                    trigger: this.countEl,
                    start: 'top 90%',
					end: 'bottom 50%',
					// markers: true
                },
            });
        });
    }
	// initAnimationNumber() {     
    //     this.$numbresAnimation.forEach((item, index) => {
    //         this.countEl = item;
    //         gsap.to(this.countEl, {
    //             innerHTML:this.countEl.parentNode.getAttribute("data-number"),
    //             snap: {
    //                 innerHTML: 1
    //             },
    //         	duration: 2,
    //             scrollTrigger: {
    //                 trigger: this.countEl,
    //                 start: 'top 90%',
	// 				end: 'bottom 50%',
	// 				// markers: true
    //             },
    //         });
    //     });
    // }
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default FeaturedContentTextImageNumbers;
